import React from 'react';
import LegalPage from './LegalPage';
import { TERMS } from './legalContent';

const Terms: React.FC = () => <LegalPage doc={TERMS} />;

export default Terms;
